<template>
  <div class="container">
    <div class="nav-wrapper">
      <div class="nav-context">
        <div class="left-logo"></div>
        <el-popover
          style="z-index: 999"
          placement="bottom"
          width="96px"
          trigger="click"
          @hide="visiblePopover = false">
          <div class="content-wrapper" style="z-index: 999 ;display: flex; justify-content: center; align-content: flex-start; flex-wrap: wrap;">
            <a style="width:84px; font-weight: 400; font-size: 14px; color: #171A1D; line-height: 20px; text-align: left; font-style: normal; cursor: pointer; text-decoration: none;" @mouseover="mouseOverPopover" @mouseleave="mouselevalPopover" class="buy-card-guide" href="https://resources.passionpanda.cn/protocol/user-buy-guide.pdf" target="_blank">购卡章程</a>
          </div>
          <div style="height: 11px;"></div>
          <div class="content-wrapper" style="z-index: 999 ;display: flex; justify-content: center; align-content: flex-start; flex-wrap: wrap;">
            <a @click="showModal = true" style="width:84px; font-weight: 400; font-size: 14px; color: #171A1D; line-height: 20px; text-align: left; font-style: normal; cursor: pointer; text-decoration: none;" @mouseover="mouseOverPopover" @mouseleave="mouselevalPopover" class="buy-card-guide"  target="_blank">信息对接查询</a>
          </div>
          
          <div class="right-tips" slot="reference" @click="visiblePopover = !visiblePopover">
            <!-- <span>信息公开</span>
            <img v-if="!visiblePopover" style="width: 14px; height: 14px; margin-left: 4px;" src="../assets/arrow-down.png"/>
            <img v-if="visiblePopover" style="width: 14px; height: 14px; margin-left: 4px;" src="../assets/arrow-up.png"/> -->
          </div>
          
        </el-popover>
      </div>
    </div>
    <div class="banner-wrapper">
      <div class="banner-context">
        <div class="banner-slogan">
          <span class="banner-slogan-text" style="font-weight: 550;">启乘无忧</span>
          <span class="banner-slogan-text" style="font-size:60px;">让每一份潜力都被看见</span>
        </div>
        <div class="banner-slogan-tips">
          <span class="banner-slogan-tips-text">职业规划 · 校企协同 · 智能实训 · 终身发展</span>
        </div>
        <div class="banner-bottom-statistics">
          <div class="banner-bottom-statistics-item">
            <div class="statistics-item-icon"></div>
            <div class="statistics-item-info">
              <span class="statistics-item-info-top">
                <count-to :start-val="0" :end-val="60" :duration="3600" class="statistics-item-info-count" />
              </span>
              <span class="statistics-item-info-bottom">合作高校(所）</span>
            </div>
          </div>
          <div class="banner-bottom-statistics-item">
            <div class="statistics-item-icon" id="statistics-item-icon2" style="margin-left: 52px;"></div>
            <div class="statistics-item-info">
              <span class="statistics-item-info-top">
                <count-to :start-val="0" :end-val="500000" :duration="3600" class="statistics-item-info-count" />
              </span>
              <span class="statistics-item-info-bottom">累计服务学员</span>
            </div>
          </div>
          <div class="banner-bottom-statistics-item">
            <div class="statistics-item-icon" id="statistics-item-icon3" style="margin-left: 63px;"></div>
            <div class="statistics-item-info">
              <span class="statistics-item-info-top">
                <count-to :start-val="0" :end-val="98" :duration="3600" id="statistics-item-info-count" />
                <span id="statistics-item-info-count">.</span>
                <count-to :start-val="0" :end-val="80" :duration="3600" id="statistics-item-info-count" />
              </span>
              <span class="statistics-item-info-bottom">客户满意度</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="who-need-plan-wrapper">

      <div class="who-need-plan-context">
        <div class="who-need-plan-left-panel" data-aos-offset="-300" data-aos="fade-up"
          data-aos-anchor-placement="center-bottom" data-aos-delay="0">
          <div class="who-need-plan-title">
            <div class="who-need-plan-title-context">
              <span class="who-need-plan-title-text">谁需要</span>
              <span class="who-need-plan-title-text">职业规划？</span>
            </div>
          </div>
          <div class="who-need-plan-img-context">
            <div class="who-need-plan-img"></div>
          </div>
        </div>
        <div class="who-need-plan-right-panel">
          <div class="right-panel-item" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-delay="0">
            <div class="right-panel-item-context">
              <div class="left-tips-wrapper">
                <div class="tips-title">
                  <span class="tips-title-text">新生及在校生</span>
                </div>
                <div class="tips-content">
                  <span class="tips-content-text">深知”现在不行动，毕业即失业“，但别人在抢跑，你还在原地“没有头绪”？</span>
                </div>
              </div>
              <div class="right-img"></div>
            </div>
          </div>
          <div class="right-panel-item" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-delay="0">
            <div class="right-panel-item-context">
              <div class="left-tips-wrapper">
                <div class="tips-title">
                  <span class="tips-title-text">应届毕业生</span>
                </div>
                <div class="tips-content">
                  <span class="tips-content-text">毕业在即，却发现自己的简历毫无亮点，既没有实习经历，也没有相关技能</span>
                </div>
              </div>
              <div class="right-img"></div>
            </div>
          </div>
          <div class="right-panel-item" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-delay="0">
            <div class="right-panel-item-context">
              <div class="left-tips-wrapper">
                <div class="tips-title">
                  <span class="tips-title-text">职场困惑者</span>
                </div>
                <div class="tips-content">
                  <span class="tips-content-text">在职场摸爬滚打，却发现职业发展陷入瓶颈，看不到未来的方向</span>
                </div>
              </div>
              <div class="right-img"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="core-product-wrapper">
      <div class="core-product-context">
        <div class="core-product-context-title" data-aos="fade-up" data-aos-anchor-placement="center-bottom"
          data-aos-delay="0">
          <span class="title">四大核心优势 构建职业发展闭环</span>
          <span class="tips">测评 - 规划 - 实训 - 就业</span>
        </div>
        <div class="product-introduce-wrapper" data-aos="fade-up" data-aos-anchor-placement="center-bottom"
          data-aos-delay="0">
          <div class="product-introduce-context">
            <div class="mini-program-introduce-wrapper">
              <div class="mini-program-introduce-context">
                <div class="product-introduce-text">
                  <span class="product-introduce-name">熊猫引才小程序</span>
                  <span class="product-introduce-tips">大学生职业成长一站式智能平台，助力学生明确职业方向，提升求职竞争力，实现职业理想</span>
                </div>
                <div class="product-introduce-menu-wrapper">
                  <div class="product-introduce-menu-item">
                    <div class="icon"></div>
                    <span class="label">权威职业测评</span>
                  </div>
                  <div class="product-introduce-menu-item">
                    <div class="icon" style="margin-left: 56px;"></div>
                    <span class="label">AI简历优化</span>
                  </div>
                  <div class="product-introduce-menu-item">
                    <div class="icon"></div>
                    <span class="label">AI模拟面试</span>
                  </div>
                  <div class="product-introduce-menu-item">
                    <div class="icon" style="margin-left: 56px;"></div>
                    <span class="label">能力训练场</span>
                  </div>
                  <div class="mini-program-scan-code"></div>
                </div>
              </div>
            </div>
            <div class="mini-program-phone-img-wrapper">
              <div class="phone-img-1"></div>
              <div class="phone-img-2"></div>
            </div>
          </div>
        </div>
        <div class="product-card-wrapper">
          <div class="product-card-context">
            <div class="product-card-item" data-aos="fade-left" data-aos-anchor-placement="center-bottom"
              data-aos-delay="0">
              <div class="card-img-1"></div>
              <div class="first-card-context">
                <div class="card-context">
                  <div class="introduce">
                    <span class="title">多维导师矩阵</span>
                    <span class="tips">专家协同破解职业发展全链路难题</span>
                  </div>
                  <div class="card-process-wrapper">
                    <div class="process-line-wrapper">
                      <div class="process-dot"></div>
                      <div class="process-dot"></div>
                      <div class="process-dot"></div>
                      <div class="process-line"></div>
                    </div>
                    <div class="process-content-wrapper">
                      <div class="process-content">
                        <div class="title">生涯规划师</div>
                        <div class="arrow"></div>
                        <div class="tips">明确“往哪走” </div>
                      </div>
                      <div class="process-content">
                        <div class="title">企业培训师</div>
                        <div class="arrow"></div>
                        <div class="tips">解决“心态崩” </div>
                      </div>
                      <div class="process-content">
                        <div class="title">心理咨询师</div>
                        <div class="arrow"></div>
                        <div class="tips">指导“怎么赢” </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="product-card-item" data-aos="fade-up" data-aos-anchor-placement="center-bottom"
              data-aos-delay="0">
              <div class="card-img-2"></div>
              <div class="second-card-context">
                <div class="card-context">
                  <div class="introduce">
                    <span class="title">进阶培养课程体系</span>
                    <span class="tips">多维课程组合发力，加速理想Offer抵达！</span>
                  </div>
                  <div class="card-content-wrapper">
                    <div class="button">
                      <span class="text">32节系列职业规划课</span>
                    </div>
                    <div class="button">
                      <span class="text">5h工作坊</span>
                    </div>
                    <div class="button">
                      <span class="text">3h专题讲座</span>
                    </div>
                    <div class="button">
                      <span class="text">“微专业”课程</span>
                    </div>
                    <div class="button">
                      <span class="text">8周训练营</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="product-card-item" data-aos="fade-right" data-aos-anchor-placement="center-bottom"
              data-aos-delay="0">
              <div class="card-img-3"></div>
              <div class="third-card-context">
                <div class="card-context">
                  <div class="introduce">
                    <span class="title" style="text-align: left">深度企业合作网络</span>
                    <span class="tips" style="text-align: left">直连名企万岗，助力锁定理想职位！</span>
                  </div>
                  <div class="card-content-wrapper">
                    <div class="button">
                      <span class="title" style="text-align: left;  margin-left: 21px;">合作企业库</span>
                      <span class="tips" style="text-align: left;  margin-left: 21px;">央企、国企、大厂等120+合作企业</span>
                    </div>
                    <div class="button">
                      <span class="title" style="text-align: left; margin-left: 21px;">岗位资源库</span>
                      <span class="tips" style="text-align: left;  margin-left: 21px;">动态更新海量实习/校招岗位</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="eight-service-wrapper">
      <div class="eight-service-context">
        <div class="service-header-wrapper" data-aos="fade-up" data-aos-anchor-placement="center-bottom"
          data-aos-delay="0">
          <div class="service-header-left-introduce">
            <div class="title">八大职业赋能服务</div>
            <div class="tips">全方位助力职场成长与就业发展</div>
          </div>
          <div class="service-header-right-control">
            <div class="previous" @click="previousOne"></div>
            <div class="next" @click="nextOne"></div>
          </div>
        </div>
        <div class="service-content" data-aos="fade-up" data-aos-anchor-placement="center-bottom">
          <el-carousel height="860px" interval="5000" indicator-position="none" ref="carouselRef" arrow="never" @change='changeMethod'
            :initial-index="index">
            <el-carousel-item v-for="(item, index) in 2" :key="item">
              <div class="content-list" v-if="index == 0">
                <div class="item">
                  <div class="information-content">
                    <div class="title">职业全景导航系统</div>
                    <div class="text">
                      通过整合权威职业测评、AI驱动的简历优化与模拟面试、详实求职攻略及实战能力训练场，为学生提供从自我认知到能力提升、直至成功求职的一站式智能解决方案。
                    </div>
                    <div class="tag-box">
                      <div class="tag-item">霍兰德职业兴趣</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">MBTI性格测试</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">AI简历优化</div>
                      <div class="tag-item">AI模拟面试</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">求职攻略</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">能力训练场</div>
                    </div>

                    <learn-more urlPath='/CareerPanorama'/>

                  </div>
                </div>
                <div class="item">
                  <div class="information-content">
                    <div class="title">职业规划课程</div>
                    <div class="text" style="height: 62px; width: 534px">
                      系统培养AI时代可持续职业竞争力，赋能学生从精准定位、求职攻坚到职场跃升的全周期发展。
                    </div>

                    <div class="tag-box" style="width: 500px; height: 128px">
                      <div class="tag-item">职业探索</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">优势挖掘</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">竞争力分析</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">笔/面试技巧</div>
                      <div class="tag-item">转型策略</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">简历撰写</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">市场洞察</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">人际关系</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">终身学习</div>
                    </div>

                    <learn-more urlPath='/CareerPlanning' marginValue='11'/>

                  </div>
                </div>
                <div class="item" style="height: 380px;">
                  <div class="information-content" style="height: 378px;">
                    <div class="title">专家一对一规划</div>
                    <div class="text" style="height: 62px;">
                      一对一深度定制全职业周期解决方案，从精准定位、求职攻坚到在职护航，系统性赋能职业竞争力跃迁与高质
                    </div>
                    <div class="tag-box" style="width: 460px;">
                      <div class="tag-item">职业定位</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">发展规划</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">面试辅导</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">简历深化</div>
                      <div class="tag-item">职场解惑</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">求职陪跑</div>
                    </div>

                    <learn-more urlPath='/Specialist' />
                  </div>
                </div>
                <div class="item" style="height: 380px;">
                  <div class="information-content" style="height: 378px;">
                    <div class="title">名企直通计划</div>
                    <div class="text" style="height: 62px; width: 534px">
                      开放名企参访、实习岗位及行业沙龙三大资源通道，深度触达职场新生态，前置积累实战经验与人脉势能。
                    </div>

                    <div class="tag-box" style="width: 500px; height: auto;">
                      <div class="tag-item">企业参访</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">实习岗位</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">沙龙分享</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">海量资源库</div>
                    </div>
                    <learn-more urlPath='none' marginValue='70'/>
                  </div>
                </div>
              </div>
              <div class="content-list" v-else>
                <div class="item">
                  <div class="information-content">
                    <div class="title">生涯探索活动</div>
                    <div class="text" style="width: 532px; height:62px;">
                      激活校园成长新场景！打通职业认知与实战通道，融入权益保护，打造安全发展底座，实现能力跃升。
                    </div>
                    <div class="tag-box" style="width: 540px;">
                      <div class="tag-item">校内双选会</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">政策解读会</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">职业发展解读</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">劳动权益保护</div>
                      <div class="tag-item">防诈知识科普</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">职业规划挑战赛</div>
                    </div>

                    <learn-more urlPath='none' marginValue='57'/>

                  </div>
                </div>
                <div class="item">
                  <div class="information-content">
                    <div class="title">心理咨询辅导</div>
                    <div class="text" style="height: 62px; width: 534px">
                      全维度守护心理健康！专业疏导学业压力、情感困扰及职业焦虑，提供科学情绪管理工具与树洞倾诉空间，护航青春成长关键期。
                    </div>

                    <div class="tag-box" style="width: 500px; height: 82px">
                      <div class="tag-item">求职受挫</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">情感问题</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">焦虑抑郁</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">学业压力</div>
                      <div class="tag-item">人际关系</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">树洞倾诉</div>
                    </div>

                    <learn-more urlPath='none' marginValue='57'/>
                  </div>
                </div>
                <div class="item" style="height: 380px;">
                  <div class="information-content" style="height: 378px;">
                    <div class="title">校企生涯服务站</div>
                    <div class="text" style="height: 62px; width:532px;">
                      通过全场景工作环节模拟、职业必备技能训练提升训练、产业政策解读、双导师机制等举措，培育面向企业的实用性人才。
                    </div>
                    <div class="tag-box" style="width: 532px;height:auto;">
                      <div class="tag-item">实训基地</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">双导师机制</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">工作场景模拟</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">微专业课程</div>
                    </div>
                    <learn-more urlPath='none' marginValue='72'/>
                  </div>
                </div>
                <div class="item" style="height: 380px;">
                  <div class="information-content" style="height: 378px;">
                    <div class="title">就业政策智库</div>
                    <div class="text" style="height: 62px; width: 534px">
                      一站式聚合全国31个省份，共计163个地市级最新权威政策，涵盖落户补贴、就业创业扶持、专项引进计划等内容。
                    </div>

                    <div class="tag-box" style="width: 500px; height: auto;">
                      <div class="tag-item">企业参访</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">实习岗位</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">沙龙分享</div>
                      <div style="width: 10px"></div>
                      <div class="tag-item">海量资源库</div>
                    </div>

                    <learn-more urlPath='none' marginValue='72'/>
                  </div>
                </div>
              </div>

            </el-carousel-item>
          </el-carousel>
        </div>

        <!--指示器-->
        <div class="indicator-box">
          <div class="indicator">
            <div style="height:30px;" @click="setActive(0)">
              <div :class="[{ indicator_item: true }, { active: index == 0 }]" ></div>
            </div>
            <div style="height:30px;" @click="setActive(1)">
              <div :class="[{ indicator_item: true }, { active: index == 1 }]"></div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!--导师团队-->
    <div class="mentor-team">
      <div class="team"  >
        <div style="height: 88px;"></div>
        <div class="mentor-title">导师团队</div>
        <div style="height: 8px;"></div>
        <div class="introduction">资深企业实战专家构成，不同于高校理论型导师</div>
        <div style="height: 107px;"></div>
        <div class="teacher-list" data-aos-anchor-placement="center-bottom" data-aos="fade-up"  data-aos-offset="-300" >

          <div class="back-panel" >
            <div class="item">
              <div class="head">
                <div style="width: 50px;"></div>
                <div>
                  <div style="height:50px;"></div>
                  <div class="name">陈莉莎</div>
                  <div style="height: 16px;"></div>
                  <div class="school">北京大学企业管理硕士<br />CCDM中国职业规划师</div>
                </div>
                <img src="../assets/chensjali.png" class="picture-mentor" style="width: 250px; height: 250px;" />
              </div>
              <div class="professional-introduction">
                <div class="content">
                  19年+高管猎聘、人才评估、人才发展等相关咨询工作经验<br />
                  9年+职业规划咨询经验，1000+案例，擅于精准地诊断职业发展问题，并提供切实有效的解决方案。
                </div>
              </div>
            </div>
          </div>

          <div class="back-panel" >
            <div class="item">
              <div class="head">
                <div style="width: 50px;"></div>
                <div>
                  <div style="height:50px;"></div>
                  <div class="name">邹璐</div>
                  <div style="height: 16px;"></div>
                  <div class="school">上海市就业服务志愿团专家<br />咨询师职业生涯规划师</div>
                </div>
                <img src="../assets/chenshali_2.png" class="picture-mentor" style="width: 250px; height: 250px;" />
              </div>
              <div class="professional-introduction">
                <div class="content">
                  近二十年深耕人力资源工作领域，曾服务于百年外企集团、英资医药上市集团 HRD<br />
                  丰富的战略性人才选拔、培养及组织搭建领域专家级经验<br />
                  丰富的就业指导及职业规划经验，累计帮助三千余人
                </div>
              </div>
            </div>
          </div>

          <div class="back-panel" style="width: 417px">
            <div class="item">
              <div class="head">
                <div style="width: 50px;"></div>
                <div>
                  <div style="height:50px;"></div>
                  <div class="name">余志刚</div>
                  <div style="height: 16px;"></div>
                  <div class="school">复旦大学、荷兰马斯<br />特里赫特管理学院MB</div>
                </div>
                <img src="../assets/yuzhigang.png" class="picture-mentor" style="width: 250px; height: 250px;" />
              </div>
              <div class="professional-introduction">
                <div class="content">
                  精通人力资源管理工作，在多家外企和民营担任人力资管理岗位，曾任人力资源副总经理、人力资源总监等岗位。<br />
                  曾在知名企业（摩托罗拉、阿斯利康、耐克等公司）和上市企业工作多年，对于人力资源和管理工作有深刻的体会
                </div>
              </div>
            </div>
          </div>

          <div class="back-panel">
            <div class="item">
              <div class="head">
                <div style="width: 50px;"></div>
                <div>
                  <div style="height:50px;"></div>
                  <div class="name">文明新</div>
                  <div style="height: 16px;"></div>
                  <div class="school">猎头公司合伙人<br />大学生就业指导老师</div>
                </div>
                <img src="../assets/wenmingxin.png" class="picture-mentor" style="width: 250px; height: 250px;" />
              </div>
              <div class="professional-introduction">
                <div class="content">
                  14年人力资源经历，11年高端招聘工作经验，辅导过10000+高管求职，曾任微彰国际猎头公司合伙人<br />
                  大学生资深就业指导老师，辅导过2000+大学生求职，华北电力大学 “大学生职业规划大赛”专家评委
                </div>
              </div>
            </div>
          </div>

          <div class="back-panel">
            <div class="item">
              <div class="head">
                <div style="width: 50px;"></div>
                <div>
                  <div style="height:50px;"></div>
                  <div class="name">林增祥</div>
                  <div style="height: 16px;"></div>
                  <div class="school">中科院博士后<br />生物化工博士</div>
                </div>
                <img src="../assets/linzengxiang.png" class="picture-mentor" style="width: 250px; height: 250px;" />
              </div>
              <div class="professional-introduction">
                <div class="content">
                  资深职业规划导师，10年企业培训经历荣获新疆大学生职业规划赛评委专家青年创业导师等<br />
                  擅长运用结构化思维与先进教学理念，引导学生探索自我，帮助学生制定个性化职业规划，提升就业竞争力
                </div>
              </div>
            </div>
          </div>

          <div class="back-panel" style="width: 417px">
            <div class="item">
              <div class="head">
                <div style="width: 50px;"></div>
                <div>
                  <div style="height:50px;"></div>
                  <div class="name">龚丹</div>
                  <div style="height: 16px;"></div>
                  <div class="school">MeetHR学院、<br />HR百科互助社特聘HR专家</div>
                </div>
                <img src="../assets/gongdang.png" class="picture-mentor" style="width: 250px; height: 250px;" />
              </div>
              <div class="professional-introduction">
                <div class="content">
                  历任多家公司HRD，8年销售管理经验、3年市场品牌管理经验、3年风险投资经验、7年人力资源总监经验<br />
                  阿里签约作家，著有商战小说《商海沧桑》创业管理类书籍《壁垒》 壁垒理论发明人
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="height:180px;"></div>
      </div>
    </div>

    <!--学员评价-->
    <div class="student-evaluation">
      <div style="height:100px;"></div>
      <div class="evaluation">学员评价</div>
      <div style="height:10px;"></div>
      <div class="slogan">从迷茫到蜕变，学员成长实录</div>

      <div style="width: 1280px; margin: 48px auto;">

        <el-carousel ref="student" @change="changeStudent" :interval="4000" indicator-position="none" type="card"
          height="420px">
          <el-carousel-item v-for="(item, index) in 5" :key="index">
            <div class="student-item" v-show="index == 0">
              <div class="school-occupation">
                <img src="../../src/assets/yu.png" class="avatar">
                <div style="margin-left: 24px; margin-top: 20px;">
                  <div class="student-name">周*宇</div>
                  <div style="height: 8px"></div>
                  <div class="student-school">重庆高职大三｜计算机专业</div>
                </div>
              </div>
              <div class="evaluation-content" style="height: 168px;">
                说实话，我一直觉得高职学生找工作挺难的。每次看招聘都要求本科优先，我连试都不敢试。后来老师鼓励我，帮助我规划了职业方向，让我重拾信心，我根据老师意见，把我的项目经历用STAR法重写了，还模拟了几次面试，最终，在今年3月的时候，我在双选会上投递了数据运维岗位，顺利通过企业面试。这是我人生中第一次真正意义上的“被看见”，感觉特别珍贵。
              </div>
            </div>

            <div class="student-item" style="width: 629px;" v-show="index == 1">
              <div class="school-occupation">
                <img src="../../src/assets/s-chenyu.png" class="avatar">
                <div style="margin-left: 24px; margin-top: 20px;">
                  <div class="student-name">陈*语</div>
                  <div style="height: 8px"></div>
                  <div class="student-school">广州某普通二本大四女生｜人力资源管理专业</div>
                </div>
              </div>
              <div class="evaluation-content" style="width: 529px;">
                我是在秋招的最后阶段才真正慌起来的，那种焦虑感越来越强烈。身边的同学不是已经拿了offer，就是在考公的路上，只有我还毫无进展。而我投递的简历都石沉大海，连一个面试机会都没有，直到我参加了启乘无忧职业认知工作坊。这个课程真的帮了我大忙，每天晚上坚持学习一个小时，系统地学如何用结构化思维撰写简历并准备面试，反复练习行为面试法，甚至还学习了如何写商务邮件和打磨自我介绍。最终，在老师的鼓励下，我鼓起勇气投了某大型物流公司的HRBP培训生岗，没想到顺利通过了初面+终面，成功拿到了人生中第一份校招offer
              </div>
            </div>

            <div class="student-item" style="width: 629px;" v-show="index == 2">
              <div class="school-occupation">
                <img src="../../src/assets/s-cheng.png" class="avatar">
                <div style="margin-left: 24px; margin-top: 20px;">
                  <div class="student-name">赵*</div>
                  <div style="height: 8px"></div>
                  <div class="student-school">29岁｜原制造行业采购岗</div>
                </div>
              </div>
              <div class="evaluation-content" style="width: 529px;">
                我大学是机械专业，毕业后一直在一家制造企业做采购，但这几年行业萎缩，岗位压缩，晋升无望。我开始焦虑，但不知道该换行还是考研。一个朋友建议我去找启乘无忧做职业咨询。我当时预约了他们1对1咨询服务，吴老师很专业，引导我回顾职业经历、拆解我的能力模块，还帮我做了完整的职业兴趣与性格测评。最终我们锁定了“B端SaaS销售+项目支持”，既不脱离我原本的行业知识，又更具成长空间。我根据建议更新了简历，也在平台筛选了几个岗位，最终顺利转岗到一家工业软件公司做项目支持。现在我每天都在学新东西，也开始做PPT方案汇报，整个人状态都不一样了。
              </div>
            </div>

            <div class="student-item" v-show="index == 3">
              <div class="school-occupation">
                <img src="../../src/assets/s-lile.png" class="avatar">
                <div style="margin-left: 24px; margin-top: 20px;">
                  <div class="student-name">李*乐</div>
                  <div style="height: 8px"></div>
                  <div class="student-school">26岁｜毕业3年｜行政文员转行用户运营</div>
                </div>
              </div>
              <div class="evaluation-content">
                我工作三年了，但一直在做琐碎行政工作，没有成长空间。想转岗做互联网运营，但看完全不知道该从哪开始补能力。后来在抖音刷到“启乘无忧训练营”，报名了他们的互联网运营微专业课。课程是由前大厂运营总监带队讲解，不光教知识，还模拟真实项目案例，从零学起数据分析、用户行为、增长逻辑，还做了一个完整实战作品集。
                最终我成功转岗用户运营，薪资提升40%，启乘帮我跨过了“不敢迈出的那一步”。
              </div>
            </div>

            <div class="student-item" style="width: 629px;" v-show="index == 4">
              <div class="school-occupation">
                <img src="../../src/assets/s-lingxin.png" class="avatar">
                <div style="margin-left: 24px; margin-top: 20px;">
                  <div class="student-name">林*欣</div>
                  <div style="height: 8px"></div>
                  <div class="student-school">南京某本科大二学生 | 市场营销专业</div>
                </div>
              </div>
              <div class="evaluation-content" style="width: 529px;">
                大二上学期，我突然意识到自己除了和学生会经历，简历几乎一片空白。身边的同学开始找实习、考证、做项目，而我连‘我以后能干什么’都没想明白。后来学校举办了启乘无忧的职业规划讲座，让我认识到自己更适合‘内容+用户研究’这类方向，我又报名了他们的‘职业发展8周训练营’，从零开始写简历、练面试，咨询老师还帮我分析了适配的职业路径，课程结束后我调整了自己的课外活动方向，主动联系公众号做内容实习，还通过他们的校企双选功能投了一家新媒体公司的暑期岗位。最后顺利拿到了实习Offer！
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <!--指示器-->
      <div class="indicator-box">
        <div class="indicator">
          <div style="height:30px;" @click="setStudentActive(0)">
            <div :class="[{ indicator_item: true }, { active: studentIndex == 0 }]" ></div>
          </div>
          <div style="height:30px;" @click="setStudentActive(1)">
            <div :class="[{ indicator_item: true }, { active: studentIndex == 1 }]" ></div>
          </div>
          <div style="height:30px;" @click="setStudentActive(2)">
             <div :class="[{ indicator_item: true }, { active: studentIndex == 2 }]" ></div>
          </div>
          <div style="height:30px;" @click="setStudentActive(3)">
             <div :class="[{ indicator_item: true }, { active: studentIndex == 3 }]"></div>
          </div>
         <div style="height:30px;" @click="setStudentActive(4)">
          <div :class="[{ indicator_item: true }, { active: studentIndex == 4 }]" @click="setStudentActive(4)"></div>
         </div>
        </div>
      </div>

    </div>

    <!---合作伙伴--->
    <div class="partner">
      <div class="introduction">启乘无忧与全国 <br /> <span style="color:#FF6E00;">超60所</span>高校建立了深度合作的伙伴关系</div>
      <div class="logos">
        <div class="scroller">
          <div class="logos-one scroller_inner">
            <img class="logo" src="../assets/logo/logo_1.png" />
            <img class="logo" src="../assets/logo/logo_2.png" />
            <img class="logo" src="../assets/logo/logo_3.png" />
            <img class="logo" src="../assets/logo/logo_4.png" />
            <img class="logo" src="../assets/logo/logo_5.png" />
            <img class="logo" src="../assets/logo/logo_6.png" />
            <img class="logo" src="../assets/logo/logo_7.png" />
            <img class="logo" src="../assets/logo/logo_8.png" />
            <img class="logo" src="../assets/logo/logo_9.png" />
            <img class="logo" src="../assets/logo/logo_10.png" />
            <img class="logo" src="../assets/logo/logo_11.png" />
            <img class="logo" src="../assets/logo/logo_12.png" />
            <img class="logo" src="../assets/logo/logo_13.png" />
            <img class="logo" src="../assets/logo/logo_14.png" />
            <img class="logo" src="../assets/logo/logo_15.png" />
            <img class="logo" src="../assets/logo/logo_16.png" />
            <img class="logo" src="../assets/logo/logo_17.png" />
            <img class="logo" src="../assets/logo/logo_18.png" />
            <img class="logo" src="../assets/logo/logo_19.png" />
            <img class="logo" src="../assets/logo/logo_20.png" />
            <img class="logo" src="../assets/logo/logo_21.png" />
            <img class="logo" src="../assets/logo/logo_22.png" />
            <img class="logo" src="../assets/logo/logo_23.png" />
            <img class="logo" src="../assets/logo/logo_24.png" />
            <img class="logo" src="../assets/logo/logo_25.png" />
            <img class="logo" src="../assets/logo/logo_26.png" />
            <img class="logo" src="../assets/logo/logo_1.png" />
            <img class="logo" src="../assets/logo/logo_2.png" />
            <img class="logo" src="../assets/logo/logo_3.png" />
            <img class="logo" src="../assets/logo/logo_4.png" />
            <img class="logo" src="../assets/logo/logo_5.png" />
            <img class="logo" src="../assets/logo/logo_6.png" />
            <img class="logo" src="../assets/logo/logo_7.png" />
            <img class="logo" src="../assets/logo/logo_8.png" />
            <img class="logo" src="../assets/logo/logo_9.png" />
            <img class="logo" src="../assets/logo/logo_10.png" />
            <img class="logo" src="../assets/logo/logo_11.png" />
            <img class="logo" src="../assets/logo/logo_12.png" />
            <img class="logo" src="../assets/logo/logo_13.png" />
            <img class="logo" src="../assets/logo/logo_14.png" />
            <img class="logo" src="../assets/logo/logo_15.png" />
            <img class="logo" src="../assets/logo/logo_16.png" />
            <img class="logo" src="../assets/logo/logo_17.png" />
            <img class="logo" src="../assets/logo/logo_18.png" />
            <img class="logo" src="../assets/logo/logo_19.png" />
            <img class="logo" src="../assets/logo/logo_20.png" />
            <img class="logo" src="../assets/logo/logo_21.png" />
            <img class="logo" src="../assets/logo/logo_22.png" />
            <img class="logo" src="../assets/logo/logo_23.png" />
            <img class="logo" src="../assets/logo/logo_24.png" />
            <img class="logo" src="../assets/logo/logo_25.png" />
            <img class="logo" src="../assets/logo/logo_26.png" />
          </div>
        </div>
        <div style="height: 30px;"></div>
        <div class="scroller">
          <div class="logos-one scroller_inner_two">
            <img class="logo" src="../assets/logo/logo_27.png" />
            <img class="logo" src="../assets/logo/logo_28.png" />
            <img class="logo" src="../assets/logo/logo_29.png" />
            <img class="logo" src="../assets/logo/logo_30.png" />
            <img class="logo" src="../assets/logo/logo_31.png" />
            <img class="logo" src="../assets/logo/logo_32.png" />
            <img class="logo" src="../assets/logo/logo_33.png" />
            <img class="logo" src="../assets/logo/logo_34.png" />
            <img class="logo" src="../assets/logo/logo_35.png" />
            <img class="logo" src="../assets/logo/logo_36.png" />
            <img class="logo" src="../assets/logo/logo_37.png" />
            <img class="logo" src="../assets/logo/logo_38.png" />
            <img class="logo" src="../assets/logo/logo_39.png" />
            <img class="logo" src="../assets/logo/logo_40.png" />
            <img class="logo" src="../assets/logo/logo_41.png" />
            <img class="logo" src="../assets/logo/logo_42.png" />
            <img class="logo" src="../assets/logo/logo_43.png" />
            <img class="logo" src="../assets/logo/logo_44.png" />
            <img class="logo" src="../assets/logo/logo_45.png" />
            <img class="logo" src="../assets/logo/logo_46.png" />
            <img class="logo" src="../assets/logo/logo_47.png" />
            <img class="logo" src="../assets/logo/logo_48.png" />
            <img class="logo" src="../assets/logo/logo_49.png" />
            <img class="logo" src="../assets/logo/logo_50.png" />
            <img class="logo" src="../assets/logo/logo_51.png" />
            <img class="logo" src="../assets/logo/logo_52.png" />
            <img class="logo" src="../assets/logo/logo_27.png" />
            <img class="logo" src="../assets/logo/logo_28.png" />
            <img class="logo" src="../assets/logo/logo_29.png" />
            <img class="logo" src="../assets/logo/logo_30.png" />
            <img class="logo" src="../assets/logo/logo_31.png" />
            <img class="logo" src="../assets/logo/logo_32.png" />
            <img class="logo" src="../assets/logo/logo_33.png" />
            <img class="logo" src="../assets/logo/logo_34.png" />
            <img class="logo" src="../assets/logo/logo_35.png" />
            <img class="logo" src="../assets/logo/logo_36.png" />
            <img class="logo" src="../assets/logo/logo_37.png" />
            <img class="logo" src="../assets/logo/logo_38.png" />
            <img class="logo" src="../assets/logo/logo_39.png" />
            <img class="logo" src="../assets/logo/logo_40.png" />
            <img class="logo" src="../assets/logo/logo_41.png" />
            <img class="logo" src="../assets/logo/logo_42.png" />
            <img class="logo" src="../assets/logo/logo_43.png" />
            <img class="logo" src="../assets/logo/logo_44.png" />
            <img class="logo" src="../assets/logo/logo_45.png" />
            <img class="logo" src="../assets/logo/logo_46.png" />
            <img class="logo" src="../assets/logo/logo_47.png" />
            <img class="logo" src="../assets/logo/logo_48.png" />
            <img class="logo" src="../assets/logo/logo_49.png" />
            <img class="logo" src="../assets/logo/logo_50.png" />
            <img class="logo" src="../assets/logo/logo_51.png" />
            <img class="logo" src="../assets/logo/logo_52.png" />
          </div>
        </div>

        <div class="left-shadow"></div>
        <div class="right-shadow"></div>

         <div class="more-not" v-if="!viewMore" @mouseenter="viewMore = true">
          <div class="more-txt">查看更多</div>
          <div style="width:8px;"></div>
          <img src="../assets/right-huang.png" style="width:14px; height:12px;" />
        </div>
        <div class="more" @click="routeJump('/PartnerInstitutions')" @mouseleave="viewMore = false" v-else>
          <div class="more-txt">查看更多</div>
          <div style="width:8px;"></div>
          <img src="../assets/right.png" style="width:14px; height:12px;" />
        </div>
      </div>
    </div>


    <contact-us />
    <!--回到头部-->
    <free-consultation />

    <!--弹出层-->
    <mask-layer 
    :visible.sync="showModal"
      title="弹窗标题"
      width="600px"
      :mask-closable="false"
      @confirm="handleConfirm"
      @cancel="handleCancel"
    />
  </div>
</template>

<script>
import freeConsultation from '../components/FreeConsultation/freeConsultation.vue'
import contactUs from '../components/ContactUs/contactUs.vue'
import CountTo from 'vue-count-to'
import learnMore from '../components/LearnMore/learnMore.vue'
import maskLayer from '../components/MaskLayer/maskLayer.vue'
export default {
  name: 'IndexPage',
  components: {
    CountTo,
    freeConsultation,
    contactUs,
    learnMore,
    maskLayer
  },
  data () {
    return {
      showModal: false,
      index: 0,
      studentIndex: 0,
      telephone: '',
      region: '',
      viewMore: false,
      visiblePopover: false
    }
  },
  methods: {
    handleConfirm(){

    },
    handleCancel(){
      this.showModal = false;
    },
    mouseOverPopover(e) {
      e.srcElement.style.color = "#FF6E00";
    },

    mouselevalPopover(e) {
      e.srcElement.style.color = "";
    },

    routeJump(path){
      this.$router.push(path);
    },

    previousOne () {
      console.log(this.$refs.carouselRef)
      this.$refs.carouselRef.prev()
    },

    nextOne () {
      this.$refs.carouselRef.next()
    },

    setActive (index) {
      this.$refs.carouselRef.setActiveItem(index)
    },

    setStudentActive (indexStudentActive) {
      this.$refs.student.setActiveItem(indexStudentActive)
    },
    changeStudent (indexStudent) {
      this.studentIndex = indexStudent
    },
    changeMethod (indexChange) {
      this.index = indexChange
    }
  }
}
</script>

<style scoped lang="scss">
@keyframes scroll {
  to {
    transform: translateX(calc(-50% - 0.6rem));
  }
}

@keyframes scro {
  to {
    transform: translateX(calc(-50% - 0.6rem));
  }
}

.el-carousel__item h3 {
  color: #FF6E00;
  font-size: 18px;
  opacity: 0.75;
  margin: 0;
}

.container {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  overflow: hidden;

  .nav-wrapper {
    width: 100%;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255,255,255,0.5);
    box-shadow: 0px 1px 0px 0px rgba(126,134,142,0.16);
    backdrop-filter: blur(20px);
    position: fixed;
    top: 0;
    z-index: 99;
    .nav-context {
      width: 1280px;
      height: 64px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left-logo {
        width: 141px;
        height: 40px;
        background-image: url("../assets/nav-logo.png");
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
      .content-wrapper:hover {
        background: red;
      }
      .right-tips {
        width: auto;
        height: 22rpx;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
      }
    }
  }

  .banner-wrapper {
    width: 100%;
    height: 980px;
    display: flex;
    justify-content: center;
    align-content: flex-end;
    flex-wrap: wrap;
    background-image: url("../assets/index-page-banner-background.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    .banner-context {
      width: 1280px;
      min-height: 654px;
      margin-bottom: 67px;
      display: flex;
      justify-content: flex-start;
      align-content: flex-start;
      flex-wrap: wrap;

      .banner-slogan {
        width: 100%;
        min-height: 188px;
        display: flex;
        justify-content: flex-start;
        align-content: flex-start;
        flex-wrap: wrap;



        .banner-slogan-text {
          width: 100%;
          height: auto;
          font-family: DOUYINSANSBOLD, DOUYINSANSBOLD;
          font-weight: normal;
          font-size: 66px;
          color: #FF6E00;
          line-height: 94px;
          letter-spacing: 1px;
          text-align: left;
          font-style: normal;
        }

        .banner-slogan-text:nth-child(2) {
          color: #171A1D;
        }
      }

      .banner-slogan-tips {
        width: 100%;
        min-height: 50px;
        display: flex;
        justify-content: flex-start;
        align-content: end;
        flex-wrap: wrap;

        .banner-slogan-tips-text {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 24px;
          color: rgba(23, 26, 29, 0.6);
          line-height: 33px;
          letter-spacing: 2px;
          text-align: left;
          font-style: normal;
        }
      }

      .banner-bottom-statistics {
        width: 100%;
        min-height: 390px;
        display: flex;
        justify-content: space-between;
        align-content: flex-end;
        flex-wrap: wrap;

        .banner-bottom-statistics-item {
          width: 413px;
          height: 168px;
          background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.6) 100%);
          box-shadow: 0px 6px 10px 0px rgba(192, 192, 192, 0.15);
          border-radius: 15px;
          border-image: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.6)) 1 1;
          backdrop-filter: blur(10px);
          margin-top: 10px;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .statistics-item-icon {
            width: 100px;
            height: 100px;
            background-image: url("../assets/index-banner-hezuo-icon.png");
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            margin-left: 80px;
          }

          #statistics-item-icon2 {
            background-image: url("../assets/index-banner-xueyuan-icon.png");
          }

          #statistics-item-icon3 {
            background-image: url("../assets/index-banner-dainzan-icon.png");
          }

          .statistics-item-info {
            width: auto;
            height: 100px;
            display: flex;
            justify-content: flex-start;
            align-content: space-between;
            flex-wrap: wrap;
            margin-left: 16px;

            .statistics-item-info-top {
              width: 100%;
              height: 60px;
              display: flex;
              justify-content: flex-start;
              align-items: flex-end;

              .statistics-item-info-count {
                width: auto;
                height: 56px;
                font-family: DINAlternate, DINAlternate;
                font-weight: bold;
                font-size: 48px;
                color: #171A1D;
                line-height: 56px;
                text-align: left;
                font-style: normal;
                position: relative;
              }

              .statistics-item-info-count::after {
                content: "+";
                position: absolute;
                bottom: -5px;
                font-size: 38px;
              }

              #statistics-item-info-count {
                width: auto;
                height: 56px;
                font-family: DINAlternate, DINAlternate;
                font-weight: bold;
                font-size: 48px;
                color: #171A1D;
                line-height: 56px;
                text-align: left;
                font-style: normal;
                position: relative;
              }

              #statistics-item-info-count:nth-child(1)::after {
                content: "";
                position: absolute;
              }

              #statistics-item-info-count:nth-child(2)::after {
                content: "";
                position: absolute;
              }

              #statistics-item-info-count::after {
                content: "%";
                position: absolute;
                font-size: 35px;
              }
            }

            .statistics-item-info-bottom {
              width: 100%;
              height: 38px;
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 20px;
              color: #171A1D;
              line-height: 28px;
              text-align: left;
              font-style: normal;
            }
          }
        }
      }
    }
  }

  .who-need-plan-wrapper {
    width: 100%;
    min-height: 1000px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background-image: url("../assets/who-need-plan-background.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    .who-need-plan-context {
      width: 1280px;
      min-height: 768px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 119px;
      flex-wrap: wrap;

      .who-need-plan-left-panel {
        width: 520px;
        height: 768px;
        display: flex;
        justify-content: flex-start;
        align-content: flex-start;
        flex-wrap: wrap;
        background-image: url("../assets/who-need-plan-left-panel.png");
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;

        .who-need-plan-title {
          width: 100%;
          height: 168px;
          display: flex;
          justify-content: flex-start;
          align-items: flex-end;
          padding-left: 62px;

          .who-need-plan-title-context {
            width: 100%;
            height: 109px;
            display: flex;
            justify-content: flex-start;
            align-content: space-between;
            flex-wrap: wrap;

            .who-need-plan-title-text {
              width: 100%;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 36px;
              color: #171A1D;
              line-height: 50px;
              text-align: left;
              font-style: normal;
            }
          }
        }

        .who-need-plan-img-context {
          width: 100%;
          height: 505px;
          display: flex;
          justify-content: flex-start;
          align-items: flex-end;
          padding-left: 29px;

          .who-need-plan-img {
            width: 458px;
            height: 446px;
            background-image: url("../assets/who-need-plan-img.png");
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }

      .who-need-plan-left-panel:hover {
        transform: scale(1.03);
      }

      .who-need-plan-right-panel {
        max-width: 738px;
        height: 768px;
        display: flex;
        justify-content: flex-start;
        align-content: space-between;
        flex-wrap: wrap;

        .right-panel-item {
          max-width: 738px;
          height: 240px;
          display: flex;
          justify-content: flex-start;
          align-items: flex-end;
          padding-left: 88px;
          background: #FFEADB;
          border-radius: 24px;
          border: 1px solid #FF6E00;
          width: 100%;

          .right-panel-item-context {
            max-width: 600px;
            height: 226px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            .left-tips-wrapper {
              width: 333px;
              height: 226px;
              display: flex;
              justify-content: flex-start;
              align-content: flex-start;
              flex-wrap: wrap;

              .tips-title {
                width: 333px;
                height: 110px;
                display: flex;
                justify-content: flex-start;
                align-items: flex-end;

                .tips-title-text {
                  width: 100%;
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 600;
                  font-size: 28px;
                  color: #171A1D;
                  line-height: 40px;
                  text-align: left;
                  font-style: normal;
                }
              }

              .tips-content {
                width: 333px;
                height: auto;
                display: flex;
                justify-content: flex-start;
                align-content: flex-end;
                flex-wrap: wrap;

                .tips-content-text {
                  width: 100%;
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 300;
                  font-size: 16px;
                  color: #171A1D;
                  line-height: 26px;
                  text-align: left;
                  font-style: normal;
                }
              }
            }

            .right-img {
              width: 226px;
              height: 226px;
              background-image: url("../assets/who-need-plan-img-right-img-1.png");
              background-size: cover;
              background-repeat: no-repeat;
              background-position: center;
            }
          }
        }

        .right-panel-item:nth-child(2) {
          background: #FFF2DB;
          border-radius: 24px;
          border: 1px solid #F4C800;

          .right-img {
            background-image: url("../assets/who-need-plan-img-right-img-2.png");
          }
        }

        .right-panel-item:nth-child(3) {
          background: #E9F4FA;
          border-radius: 24px;
          border: 1px solid rgba(0, 137, 255, 0.48);

          .right-img {
            background-image: url("../assets/who-need-plan-img-right-img-3.png");
          }
        }

        .right-panel-item:hover {
          transform: scale(1.03);
        }
      }
    }
  }

  .core-product-wrapper {
    width: 100%;
    min-height: 1415px;
    display: flex;
    justify-content: center;
    align-content: flex-start;

    .core-product-context {
      width: 1280px;
      min-height: 1212px;
      display: flex;
      justify-content: center;
      align-content: flex-start;
      flex-wrap: wrap;
      margin-top: 103px;

      .core-product-context-title {
        width: 100%;
        height: 92px;
        display: flex;
        justify-content: center;
        align-content: space-between;
        flex-wrap: wrap;

        .title {
          width: 100%;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 40px;
          color: #171A1D;
          line-height: 56px;
          text-align: center;
          font-style: normal;
        }

        .tips {
          width: 100%;
          font-family: PingFangSC, PingFang SC;
          font-weight: 300;
          font-size: 20px;
          color: rgba(23, 26, 29, 0.6);
          line-height: 28px;
          text-align: center;
          font-style: normal;
        }
      }

      .product-introduce-wrapper {
        width: 100%;
        min-height: 540px;
        display: flex;
        justify-content: center;
        align-items: flex-end;

        .product-introduce-context {
          width: 100%;
          min-height: 460px;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-wrap: wrap;
          background-image: url("../assets/core-product-background.png");
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;

          .mini-program-introduce-wrapper {
            width: 541px;
            min-height: 402px;
            display: flex;
            justify-content: flex-start;
            align-content: space-between;
            flex-wrap: wrap;

            .mini-program-introduce-context {
              width: 453px;
              min-height: 331px;
              display: flex;
              justify-content: flex-start;
              align-content: space-between;
              flex-wrap: wrap;
              margin-top: 71px;
              margin-left: 88px;

              .product-introduce-text {
                width: 344px;
                min-height: 98px;
                display: flex;
                justify-content: flex-start;
                align-content: space-between;
                flex-wrap: wrap;

                .product-introduce-name {
                  width: 100%;
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 600;
                  font-size: 28px;
                  color: #FFFFFF;
                  line-height: 40px;
                  text-align: left;
                  font-style: normal;
                }

                .product-introduce-tips {
                  width: 100%;
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 400;
                  font-size: 16px;
                  color: #FFFFFF;
                  line-height: 26px;
                  text-align: left;
                  font-style: normal;
                }
              }

              .product-introduce-menu-wrapper .product-introduce-menu-item:nth-child(2) .icon {
                background-image: url("../assets/mini-program-menu-2.png");
              }

              .product-introduce-menu-wrapper .product-introduce-menu-item:nth-child(3) .icon {
                background-image: url("../assets/mini-program-menu-3.png");
              }

              .product-introduce-menu-wrapper .product-introduce-menu-item:nth-child(4) .icon {
                background-image: url("../assets/mini-program-menu-4.png");
              }
              .product-introduce-menu-wrapper {
                width: 100%;
                height: 172px;
                display: flex;
                justify-content: space-between;
                align-content: space-between;
                flex-wrap: wrap;
                position: relative;
                margin-bottom: 20px;

                .product-introduce-menu-item {
                  transition: transform 0.2s ease-in-out;
                  width: 216px;
                  height: 80px;
                  background: linear-gradient(148deg, #FFFFFF 0%, rgba(255, 255, 255, 0.9) 100%);
                  box-shadow: 0px 6px 10px 0px rgba(192, 192, 192, 0.15);
                  border-radius: 8px;
                  border-image: linear-gradient(169deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.6)) 2 2;
                  backdrop-filter: blur(0px);
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;

                  .icon {
                    width: 32px;
                    height: 32px;
                    background-image: url("../assets/mini-program-menu-1.png");
                    background-size: cover;
                    background-position: center;
                    background-repeat: no-repeat;
                    margin-left: 25px;
                  }
                  .label {
                    width: auto;
                    margin-left: 6px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #171A1D;
                    line-height: 26px;
                    text-align: left;
                    font-style: normal;
                  }
                }

                .product-introduce-menu-item:hover {
                  transform: scale(1.03);
                }

                .mini-program-scan-code {
                  transition: transform 0.2s ease-in-out;
                  width: 119px;
                  height: 119px;
                  position: absolute;
                  top: 27px;
                  left: calc(50% - 60px);
                  background-image: url("../assets/logo-index.png");
                  background-size: cover;
                  background-position: center;
                  background-repeat: no-repeat;
                }

                .mini-program-scan-code:hover {
                  transform: scale(1.1);
                }
              }
            }
          }

          .mini-program-phone-img-wrapper {
            width: auto;
            height: auto;
            display: flex;
            justify-content: flex-start;
            align-content: flex-start;
            flex-wrap: wrap;
            margin-left: 139px;

            .phone-img-1 {
              transition: transform 0.2s ease-in-out;
              width: 250px;
              height: 443px;
              margin-top: 18px;
              background-image: url("../assets/phone-img-1.png");
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
            }

            .phone-img-1:hover {
              transform: scale(1.03);
            }

            .phone-img-2 {
              transition: transform 0.2s ease-in-out;
              width: 250px;
              height: 444px;
              margin-left: 19px;
              background-image: url("../assets/phone-img-2.png");
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
            }

            .phone-img-2:hover {
              transform: scale(1.03);
            }
          }
        }
      }

      .product-card-wrapper {
        width: 100%;
        min-height: 580px;
        display: flex;
        justify-content: center;
        align-items: flex-end;

        .product-card-context {
          width: 100%;
          min-height: 560px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          flex-wrap: wrap;

          .product-card-item {
            transition: transform 0.2s ease-in-out;
            width: 413px;
            height: 560px;
            display: flex;
            justify-content: center;
            align-content: space-between;
            flex-wrap: wrap;
            background: #FFFFFF;
            border-radius: 16px;
            border: 1px solid rgba(126, 134, 142, 0.24);

            .card-img-1 {
              width: 413px;
              height: 214px;
              background-image: url("../assets/produce-card-img-1.png");
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
            }

            .card-img-2 {
              width: 413px;
              height: 214px;
              background-image: url("../assets/produce-card-img-2.png");
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
            }

            .card-img-3 {
              width: 413px;
              height: 214px;
              background-image: url("../assets/produce-card-img-3.png");
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
            }

            .first-card-context {
              width: 413px;
              height: 346px;
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;

              .card-context {
                width: 363px;
                height: auto;
                display: flex;
                justify-content: flex-start;
                align-content: flex-start;
                flex-wrap: wrap;
                margin-top: 40px;
                margin-left: 50px;

                .introduce {
                  width: 363px;
                  height: 63px;
                  display: flex;
                  justify-content: flex-start;
                  align-content: space-between;
                  flex-wrap: wrap;

                  .title {
                    width: 100%;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    font-size: 24px;
                    color: #171A1D;
                    line-height: 33px;
                    text-align: left;
                    font-style: normal;
                    ;
                  }

                  .tips {
                    width: 100%;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: rgba(23, 26, 29, 0.6);
                    line-height: 26px;
                    text-align: left;
                    font-style: normal;
                  }
                }

                .card-process-wrapper {
                  width: 100%;
                  height: auto;
                  display: flex;
                  justify-content: flex-start;
                  align-items: flex-start;
                  margin-top: 24px;

                  .process-line-wrapper {
                    width: 12px;
                    height: 166px;
                    display: flex;
                    justify-content: flex-start;
                    align-content: flex-start;
                    flex-wrap: wrap;
                    position: relative;
                    margin-top: 7px;

                    .process-dot {
                      width: 12px;
                      height: 12px;
                      background-image: url("../assets/process-dot.png");
                      background-size: cover;
                      background-position: center;
                      background-repeat: no-repeat;
                      z-index: 2;
                    }

                    .process-dot:nth-child(2) {
                      margin-top: 42px;
                    }

                    .process-dot:nth-child(3) {
                      margin-top: 42px;
                    }

                    .process-line {
                      width: 2px;
                      height: 162px;
                      background: linear-gradient(226deg, #FF8C3B 0%, #FFF2B6 64%, rgba(255, 242, 182, 0) 100%);
                      position: absolute;
                      left: 5px;
                      top: 3px;
                      z-index: 1;
                    }
                  }
                }

                .process-content-wrapper {
                  width: calc(100% - 60px);
                  height: auto;
                  margin-left: 10px;
                  display: flex;
                  justify-content: flex-start;
                  align-content: flex-start;
                  flex-wrap: wrap;

                  .process-content {
                    width: 100%;
                    height: 26px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;

                    .title {
                      width: auto;
                      font-family: PingFangSC, PingFang SC;
                      font-weight: 400;
                      font-size: 16px;
                      color: #171A1D;
                      line-height: 26px;
                      text-align: left;
                      font-style: normal;
                    }

                    .arrow {
                      width: 43px;
                      height: 11px;
                      margin-left: 16px;
                      background-image: url("../assets/long-arrow.png");
                      background-size: cover;
                      background-repeat: no-repeat;
                      background-position: center;
                    }

                    .tips {
                      width: auto;
                      font-family: PingFangSC, PingFang SC;
                      font-weight: 400;
                      font-size: 16px;
                      color: #FF6E00;
                      line-height: 26px;
                      text-align: left;
                      font-style: normal;
                      margin-left: 16px;
                    }
                  }

                  .process-content:nth-child(2) {
                    margin-top: 28px;
                  }

                  .process-content:nth-child(3) {
                    margin-top: 28px;
                  }
                }
              }
            }

            .second-card-context {
              width: 413px;
              height: 346px;
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;

              .card-context {
                width: 373px;
                height: auto;
                display: flex;
                justify-content: flex-start;
                align-content: flex-start;
                flex-wrap: wrap;
                margin-top: 40px;
                margin-left: 40px;

                .introduce {
                  width: 363px;
                  height: 63px;
                  display: flex;
                  justify-content: flex-start;
                  align-content: space-between;
                  flex-wrap: wrap;

                  .title {
                    width: 100%;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    font-size: 24px;
                    color: #171A1D;
                    line-height: 33px;
                    text-align: left;
                    font-style: normal;
                    ;
                  }

                  .tips {
                    width: 100%;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: rgba(23, 26, 29, 0.6);
                    line-height: 26px;
                    text-align: left;
                    font-style: normal;
                  }
                }

              }

              .card-content-wrapper {
                width: 309px;
                height: 168px;
                margin-top: 24px;
                display: flex;
                justify-content: flex-start;
                align-content: space-between;
                flex-wrap: wrap;

                .button {
                  width: 177px;
                  height: 48px;
                  background: conic-gradient(from 127.86768927546447deg at 67.5269067287445% 33.941006660461426%, rgba(252, 241, 237, 0.67) 2%, #F1EEFF 12%, #EEF7FF 44%, rgba(252, 241, 237, 0.47) 59%);
                  border-radius: 8px;
                  display: flex;
                  justify-content: center;
                  align-items: center;

                  .text {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #171A1D;
                    line-height: 26px;
                    text-align: left;
                    font-style: normal;
                  }
                }

                .button:nth-child(2) {
                  width: 120px;
                  height: 48px;
                  background: conic-gradient(from 127.86768927546447deg at 67.5269067287445% 33.941006660461426%, rgba(252, 241, 237, 0.67) 2%, #F1EEFF 12%, #EEF7FF 44%, rgba(252, 241, 237, 0.47) 59%);
                  border-radius: 8px;
                  margin-left: 12px;
                }

                .button:nth-child(3) {
                  width: 122px;
                  height: 48px;
                  background: conic-gradient(from 127.86768927546447deg at 67.5269067287445% 33.941006660461426%, rgba(252, 241, 237, 0.67) 2%, #F1EEFF 12%, #EEF7FF 44%, rgba(252, 241, 237, 0.47) 59%);
                  border-radius: 8px;
                }

                .button:nth-child(4) {
                  width: 143px;
                  height: 48px;
                  background: conic-gradient(from 127.86768927546447deg at 67.5269067287445% 33.941006660461426%, rgba(252, 241, 237, 0.67) 2%, #F1EEFF 12%, #EEF7FF 44%, rgba(252, 241, 237, 0.47) 59%);
                  border-radius: 8px;
                  margin-left: 12px;
                }

                .button:nth-child(5) {
                  width: 122px;
                  height: 48px;
                  background: conic-gradient(from 127.86768927546447deg at 67.5269067287445% 33.941006660461426%, rgba(252, 241, 237, 0.67) 2%, #F1EEFF 12%, #EEF7FF 44%, rgba(252, 241, 237, 0.47) 59%);
                  border-radius: 8px;
                }
              }
            }

            .third-card-context {
              width: 413px;
              height: 346px;
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;

              .card-context {
                width: 373px;
                height: auto;
                display: flex;
                justify-content: flex-start;
                align-content: flex-start;
                flex-wrap: wrap;
                margin-top: 40px;
                margin-left: 40px;

                .introduce {
                  width: 363px;
                  height: 63px;
                  display: flex;
                  justify-content: flex-start;
                  align-content: space-between;
                  flex-wrap: wrap;

                  .title {
                    width: 100%;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    font-size: 24px;
                    color: #171A1D;
                    line-height: 33px;
                    text-align: left;
                    font-style: normal;
                  }

                  .tips {
                    width: 100%;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: rgba(23, 26, 29, 0.6);
                    line-height: 26px;
                    text-align: left;
                    font-style: normal;
                  }
                }

              }

              .card-content-wrapper {
                width: 309px;
                height: 168px;
                margin-top: 24px;
                display: flex;
                justify-content: flex-start;
                align-content: space-between;
                flex-wrap: wrap;

                .button {
                  width: 323px;
                  height: 80px;
                  background: conic-gradient(from 127.86768927546447deg at 67.5269067287445% 33.941006660461426%, rgba(252, 241, 237, 0.67) 2%, #F1EEFF 12%, #EEF7FF 44%, rgba(252, 241, 237, 0.47) 59%);
                  border-radius: 8px;
                  display: flex;
                  justify-content: center;
                  align-content: flex-start;
                  flex-wrap: wrap;

                  .title {
                    width: 100%;
                    height: 26px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    font-size: 16px;
                    color: #171A1D;
                    line-height: 26px;
                    text-align: center;
                    font-style: normal;
                    margin-top: 10px;
                  }

                  .tips {
                    width: 100%;
                    height: 26px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 300;
                    font-size: 16px;
                    color: rgba(23, 26, 29, 0.6);
                    line-height: 26px;
                    text-align: center;
                    font-style: normal;
                    margin-top: 4px;
                  }
                }
              }
            }
          }

          .product-card-item:hover {
            transform: scale(1.03);
          }
        }
      }
    }
  }

  .eight-service-wrapper {
    width: 100%;
    min-height: 1176px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background-image: url("../assets/eight-service-background.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    .eight-service-context {
      width: 1280px;
      height: auto;
      margin-top: 78px;
      display: flex;
      justify-content: flex-start;
      align-content: flex-start;
      flex-wrap: wrap;

      .indicator-box {
        height: 125px;
        width: 100%;

        .indicator {
          width: 130px;
          height: 6px;
          display: flex;
          justify-content: space-between;
          margin: 50px auto;

          .indicator_item {
            width: 60px;
            height: 6px;
            background: rgba(23, 26, 29, 0.24);
            border-radius: 3px;
          }

          .active {
            width: 60px;
            height: 6px;
            background: #FF6E00;
            border-radius: 3px;
          }
        }
      }

      .service-content {
        width: 1280px;
        height: 860px;

        .content-list {
          height: 810px;
          width: 1280px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-content: space-between;
          margin-top: 50px;

          .item {
            width: 630px;
            height: 410px;
            background: linear-gradient(to bottom, rgba(255, 102, 3, 0.5), #FFFFFF);
            /* 边框渐变 */
            border-radius: 16px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            opacity: 0.95;

            .information-content {
              width: 628px;
              height: 408px;
              background: white;
              border-radius: 16px;

              .title {
                width: 192px;
                height: 33px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 24px;
                color: #171A1D;
                line-height: 33px;
                text-align: left;
                font-style: normal;
                margin: 50px 0 0 50px;
              }

              .text {
                width: 532px;
                height: 93px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: rgba(23, 26, 29, 0.6);
                line-height: 31px;
                text-align: left;
                font-style: normal;
                margin: 10px 0 0 50px;
              }

              .tag-box {
                width: 430px;
                height: 82px;
                margin: 24px 0 0 50px;
                display: flex;
                flex-wrap: wrap;
                align-content: space-between;

                .tag-item {
                  border-radius: 6px;
                  border: 1px solid #FF6E00;
                  padding: 7px 24px;
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 400;
                  font-size: 14px;
                  color: #171A1D;
                  line-height: 22px;
                  text-align: center;
                  font-style: normal;
                  color: #FF6E00;
                }

              }
              .default-effect{
                width: 120px;
                height: 42px;
                background: #FFFFFF;
                box-shadow: inset 0px 1px 3px 0px rgba(255,255,255,0.5);
                border-radius: 21px;
                border: 2px solid #FF6E00;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 459px;
                margin-top: 26px;
                 .btn-txt {
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 500;
                  font-size: 14px;
                  color: #FF6E00;
                  line-height: 22px;
                  text-align: center;
                  font-style: normal;
                }
              }

              .for-more-details {
                width: 120px;
                height: 42px;
                background: linear-gradient(228deg, #FF6503 0%, #FF8012 100%);
                box-shadow: inset 0px 1px 3px 0px rgba(255, 255, 255, 0.5);
                border-radius: 21px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 459px;
                margin-top: 26px;
                cursor: pointer;

                .btn-txt {
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 500;
                  font-size: 14px;
                  color: #FFFFFF;
                  line-height: 22px;
                  text-align: center;
                  font-style: normal;
                }
              }

            }
          }
        }
      }

      .service-header-wrapper {
        width: 100%;
        min-height: 113px;
        margin-top: 78px;
        display: flex;
        justify-content: space-between;
        align-content: flex-start;

        .service-header-left-introduce {
          width: auto;
          min-height: 76px;
          margin-top: 2px;

          .title {
            width: auto;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 32px;
            color: #FF6E00;
            line-height: 45px;
            text-align: left;
            font-style: normal;
          }

          .tips {
            width: auto;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 40px;
            color: #171A1D;
            line-height: 56px;
            text-align: left;
            font-style: normal;
          }
        }

        .service-header-right-control {
          width: 100px;
          height: 40px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .previous {
            width: 40px;
            height: 40px;
            background-image: url("../assets/inactive-previous-icon.png");
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            cursor: pointer;
          }

          .previous:hover {
            background-image: url("../assets/active-previous-icon.png");
          }

          .next {
            width: 40px;
            height: 40px;
            background-image: url("../assets/inactive-next-icon.png");
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            cursor: pointer;
          }

          .next:hover {
            background-image: url("../assets/active-next-icon.png");
          }
        }
      }

      .eight-service-content-wrapper {
        width: 100%;
      }
    }
  }

  .mentor-team {
    width: 100%;
    min-height: 1176px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background-image: url("../assets/supervisor-background.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    .team {

      display: flex;
      flex-direction: column;
      align-items: center;

      .mentor-title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 40px;
        color: #171A1D;
        line-height: 56px;
        text-align: left;
        font-style: normal;
      }

      .introduction {
        font-family: PingFangSC, PingFang SC;
        font-weight: 300;
        font-size: 20px;
        color: rgba(23, 26, 29, 0.6);
        line-height: 28px;
        text-align: left;
        font-style: normal;

      }

      .teacher-list {
        height: 997px;
        width: 1280px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-content: space-between;

        .back-panel:hover {
          transition: transform 0.2s ease-in-out;
          transform: translateY(-20px);
          /* 向上移动20px */
        }

        .back-panel {
          width: 418px;
          /* 比实际内容宽4px（每边2px） */
          height: 464px;
          /* 比实际内容高4px（每边2px） */
          border-radius: 18px;
          /* 比实际内容圆角大2px */
          background: linear-gradient(180deg, rgba(255, 255, 255, 0), rgba(255, 110, 0, 1));
          display: flex;
          justify-content: center;
          align-items: center;

          .item {
            width: 413px;
            height: 460px;
            background: #FFFFFF;
            border-radius: 16px;

            .professional-introduction {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 16px;
              color: rgba(23, 26, 29, 0.6);
              line-height: 32px;
              text-align: left;
              font-style: normal;

              .content {
                width: 313px;
                height: auto;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: rgba(23, 26, 29, 0.6);
                line-height: 32px;
                text-align: left;
                font-style: normal;
                margin: 32px auto;
              }
            }

            .head {
              width: 413px;
              height: 188px;
              background: conic-gradient(from 127.86768927546447deg at 67.5269067287445% 33.941006660461426%, rgba(252, 241, 237, 0.67) 2%, #F1EEFF 12%, #EEF7FF 44%, rgba(252, 241, 237, 0.47) 59%);
              border-radius: 16px 16px 0px 0px;
              display: flex;
              position: relative;

              .picture-mentor {
                position: absolute;
                right: -36px;
                bottom: 0;
              }

              .name {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 24px;
                color: #171A1D;
                line-height: 33px;
                text-align: left;
                font-style: normal;
              }

              .school {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 16px;
                color: rgba(23, 26, 29, 0.6);
                line-height: 30px;
                text-align: left;
                font-style: normal;
              }
            }

          }
        }
      }
    }
  }

  .student-evaluation {
    width: 100%;
    min-height: 816px;
    background-image: url("../assets/student-evaluation.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    .indicator-box {
      width: 340px;
      height: 125px;
      width: 100%;

      .indicator {
        width: 340px;
        height: 6px;
        display: flex;
        justify-content: space-between;
        margin: 50px auto;

        .indicator_item {
          width: 60px;
          height: 6px;
          background: rgba(23, 26, 29, 0.24);
          border-radius: 3px;
        }

        .active {
          width: 60px;
          height: 6px;
          background: #FF6E00;
          border-radius: 3px;
        }
      }

    }

    .evaluation {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 40px;
      color: #171A1D;
      line-height: 56px;
      text-align: left;
      font-style: normal;
      text-align: center;
    }

    .slogan {
      font-family: PingFangSC, PingFang SC;
      font-weight: 300;
      font-size: 20px;
      color: rgba(23, 26, 29, 0.6);
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-align: center;
    }

    .student-item {
      height: 420px;
      width: 522px;
      background: #FFFFFF;
      border-radius: 16px;
      border: 1px solid white;
      backdrop-filter: blur(10px);
      margin: 0 auto;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);

      .school-occupation {
        margin-left: 50px;
        margin-top: 39px;
        display: flex;

        .student-name {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 24px;
          color: #171A1D;
          line-height: 33px;
          text-align: left;
          font-style: normal;
        }

        .student-school {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: #FF6E00;
          line-height: 30px;
          text-align: left;
          font-style: normal;
        }

        .avatar {
          width: 100px;
          height: 100px;
        }
      }

      .evaluation-content {
        width: 422px;
        height: 196px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: rgba(23, 26, 29, 0.6);
        line-height: 28px;
        text-align: justify;
        font-style: normal;
        margin: 24px auto;
      }

    }

  }

  .partner {
    height: 662px;
    width: 100%;
    background: white;

    .introduction {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 36px;
      color: #171A1D;
      line-height: 50px;
      text-align: center;
      font-style: normal;
      margin-top: 100px;
    }

    .logos {
      width: 100%;
      height: 500px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;

      .left-shadow {
        width: 320px;
        height: 300px;
        background: linear-gradient(90deg, #FFFFFF 0%, rgba(255, 255, 255, 0.7) 51%, rgba(255, 255, 255, 0) 100%);
        position: absolute;
        left: 0;
        top: 0;
      }

      .right-shadow {
        width: 318px;
        height: 300px;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.7) 49%, #FFFFFF 100%);
        position: absolute;
        right: 0;
        top: 0;
      }

      .more-not{
        width: 116px;
        height: 38px;
        background: #FFFFFF;
        box-shadow: inset 0px 1px 3px 0px rgba(255,255,255,0.5);
        border-radius: 21px;
        border: 2px solid #FF6E00;
        display: flex;
        margin: 60px auto;
        align-items: center;
        justify-content: center;
         .more-txt {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #FF6E00;
          line-height: 22px;
          text-align: center;
          font-style: normal;

        }
      }

      .more {
        width: 120px;
        height: 42px;
        background: linear-gradient(228deg, #FF6503 0%, #FF8012 100%);
        box-shadow: inset 0px 1px 3px 0px rgba(255, 255, 255, 0.5);
        border-radius: 21px;
        display: flex;
        margin: 60px auto;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .more-txt {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 22px;
          text-align: center;
          font-style: normal;

        }
      }

      .scroller {
        width: 100%;
        margin: 0 auto;
        height: auto;
        display: flex;
        overflow: hidden;

        .scroller_inner {
          display: inline-flex;
          /* 横向排列子元素 */
          animation: scroll 50s linear infinite;
          /* 动画设置 */
        }

        .scroller_inner_two {
          display: inline-flex;
          /* 横向排列子元素 */
          animation: scro 50s linear reverse infinite;
        }

        .logos-one {
          display: flex;
          justify-content: center;
          gap: 20px;

          .logo {
            width: 108px;
            height: 108px;
          }
        }
      }

    }

  }


}
</style>



// WEBPACK FOOTER //
// src/pages/IndexPage.vue